import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ImageApi from '../../../api/image';
import { TranslateApi } from '../../../api';
import moment from 'moment';

const FeedEventItem = (props) => {
  const [state, setState] = useState({
    imageUrl: '',
  });

  const [title, setTitle] = useState(props.item.post.title);
  const [location, setLocation] = useState(props.item.post.location);
  const [isTranslated, setIsTranslated] = useState(false);

  useEffect(() => {
    if (props.item.post.image.url) {
      ImageApi.getImage(props.item.post.image.url).then((imageUrl) => {
        setState({ imageUrl });
      });
    }
  }, [props.translatePostId]);


  const onTranslateClicked = async() => {
    setIsTranslated(!isTranslated)
    let translatedTitle, translatedLocation;

    if (isTranslated) {
      setTitle(props.item.post.title)
      setLocation(props.item.post.location)

      return null
    }

    if (props.currentUser.language_id) {
      const resultTitle = await TranslateApi.getTranslation(props.currentUser.language_id, title)
    if (resultTitle && resultTitle.success) {
      translatedTitle = resultTitle.data
    }

    const resultLocation = await TranslateApi.getTranslation(props.currentUser.language_id, location)
    if (resultLocation && resultLocation.success) {
      translatedLocation = resultLocation.data
    }

    if (!translatedLocation || !translatedTitle) {
      props.addAlertToAlerts({
        title: 'Message',
        message: 'Translation to your selected language is not currently available.',
        confirmBtnText: 'Okay',
      });
      setIsTranslated(false)
    } else {
      setTitle(translatedTitle)
      setLocation(translatedLocation)
    }
    } else {
      props.addAlertToAlerts({
        title: 'Message',
        message: 'User does not have a language configured.',
        confirmBtnText: 'Okay',
      });
      setIsTranslated(false)
    }
  }

  const { item, link } = props;
  const startDate = moment(item.post.start_time);

  const renderTime = (startTime, endTime) => {
    const startDate = moment(startTime);
    const endDate = moment(endTime);
    const sameDay = endTime && startDate.isSame(endDate, 'day');

    const elements = [];
    elements.push(startDate.format('HH:mma'));
    if (!sameDay) {
      elements.push(<div key="splitter1" className="feed-item-footer-splitter" />);
      elements.push(startDate.format('dddd'));
    }
    if (endTime) {
      elements.push(endDate.format(' - HH:mma'));
      elements.push(<div key="splitter2" className="feed-item-footer-splitter" />);
      elements.push(endDate.format('dddd'));
    }

    return <div className="feed-item-event-info-time">{elements}</div>;
  };

  return (
    <div className="feed-item-content">
      <div className="feed-item-event-block d-flex">
        {props.item.post.image.url && (
          <div className="feed-item-event-image-holder">
            {state.imageUrl && (
              <img className="feed-item-event-image" src={state.imageUrl} alt="event" />
            )}
          </div>
        )}

        <div className="feed-item-event-date-holder">
          <div className="feed-item-event-date">
            <span className="feed-item-event-date-month">
              {startDate.format('MMM').toUpperCase()}
            </span>
            <span className="feed-item-event-date-day">{startDate.format('DD')}</span>
          </div>
        </div>

        <div className="feed-item-event-info-holder">
          <div className="d-flex flex-column flex-grow-1">
            <Link to={link} className="feed-item-event-info-title">
              {title}
            </Link>

            {renderTime(item.post.start_time, item.post.end_time)}
            <span className="feed-item-event-info-place">{location}</span>
          </div>

          <Link to={link} className="feed-item-event-info-button">
            View Event
          </Link>
        </div>
      </div>
      <div className="feed-item-footer" style={{cursor: 'pointer', position: 'absolute', right: 25, paddingTop: 20}} onClick={onTranslateClicked}>
        <p>{`${isTranslated ? "Show original" : "Translate this"}`}</p>
      </div>
    </div>
  );
};

export default FeedEventItem;
